module.exports = __webpack_public_path__ + "img/44_18.0d70003e.png";